module.exports = __webpack_public_path__ + "media/Ice.3eb2ddfc.mp3";